import { render, staticRenderFns } from "./laboratorio.vue?vue&type=template&id=55573da2&scoped=true&"
import script from "./laboratorio.vue?vue&type=script&lang=js&"
export * from "./laboratorio.vue?vue&type=script&lang=js&"
import style0 from "./laboratorio.vue?vue&type=style&index=0&id=55573da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55573da2",
  null
  
)

export default component.exports